import { OEMSCANLIST_CONSTANTS } from '../constants/oemscanlistConstants';

export const getOemScanListRequest = (payload) => ({
  type: OEMSCANLIST_CONSTANTS.GET_OEM_SCAN_LIST_REQUEST,
  payload,
});

export const getOemScanListSuccess = (payload) => ({
  type: OEMSCANLIST_CONSTANTS.GET_OEM_SCAN_LIST_SUCCESS,
  payload,
});

export const getOemScanListFailure = (payload) => ({
  type: OEMSCANLIST_CONSTANTS.GET_OEM_SCAN_LIST_FAILURE,
  payload,
});
export const getOemNamesByAlmataRequest = (almataId) => ({
  type: OEMSCANLIST_CONSTANTS.GET_OEM_NAMES_BY_ALMATA_REQUEST,
  payload: almataId,
});

export const getOemNamesByAlmataSuccess = (payload) => ({
  type: OEMSCANLIST_CONSTANTS.GET_OEM_NAMES_BY_ALMATA_SUCCESS,
  payload,
});

export const getOemNamesByAlmataFailure = (payload) => ({
  type: OEMSCANLIST_CONSTANTS.GET_OEM_NAMES_BY_ALMATA_FAILURE,
  payload,
});